import React from "react";
import { Helmet } from "react-helmet";

function DefaultSEO() {
  return (
    <Helmet>
      <title>Sukun Cloud Consulting | Cloud & DevOps Services</title>
      <meta name="description" content="Sukun Cloud Consulting offers expert Cloud & DevOps solutions using GCP, AWS, Kubernetes, GitOps, and more." />
      <meta name="keywords" content="Cloud Consulting, DevOps, GCP, AWS, Kubernetes, GitOps, Infrastructure, SRE" />
      <meta name="author" content="Sukun Cloud Consulting" />
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Open Graph */}
      <meta property="og:title" content="Sukun Cloud Consulting | Cloud & DevOps Services" />
      <meta property="og:description" content="Helping startups and enterprises scale with Kubernetes, GitOps, GCP & AWS." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://sukuncloud.com" />
      <meta property="og:image" content="https://sukuncloud.com/logo.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Sukun Cloud Consulting" />
      <meta name="twitter:description" content="Expert Cloud & DevOps services by Sukun – GCP, AWS, Kubernetes, GitOps." />
      <meta name="twitter:image" content="https://sukuncloud.com/logo.jpg" />
    </Helmet>
  );
}

export default DefaultSEO;